/**
 * Labstep
 *
 * @module components/Filter/Deleted
 * @desc Filter to toggle between deleted items
 */

import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { PostFilterDeleted } from 'labstep-web/services/postFilter/filters/deleted';
import type React from 'react';
import { useCallback } from 'react';
import type { IDeletedFilterProps } from './types';

export const FilterDeleted: React.FC<IDeletedFilterProps> = ({
  setParams,
  searchParams,
  paramKey = 'is_deleted',
  addPostFilter,
}) => {
  const checked = searchParams[paramKey] === '1';
  const onClick = useCallback(() => {
    if (addPostFilter) {
      addPostFilter(PostFilterDeleted.getNode());
    } else {
      setParams({
        [paramKey]: checked ? undefined : '1',
      });
    }
  }, [checked, addPostFilter, setParams, paramKey]);
  return (
    <ActionComponent
      dataCy="components/Filter/Deleted"
      type="option"
      icon="trash"
      text="Deleted"
      onClick={onClick}
    />
  );
};
